module.exports = __webpack_public_path__ + "img/Fiorella.85d0629c.png";